import { ReactNode, createContext } from "react";
import useLead, { LeadType, LeadFilter } from "./hooks/useLead";

interface LeadContextProviderProps {
    children: ReactNode;
}

export interface LeadContextData {
    leads: LeadType[];
    getAllLeads: () => Promise<LeadType[] | null>;
    getLeads: (filter?: LeadFilter) => Promise<LeadType[] | null>;
    createLead: (payload: { name: string; email?: string; phone?: string }) => Promise<LeadType | null>;
    setLeads: (leads: LeadType[]) => void;
}

const initialState: LeadContextData = {
    leads: [],
    getAllLeads: async () => Promise.resolve(null),
    getLeads: async () => Promise.resolve(null),
    createLead: async () => Promise.resolve(null),
    setLeads: () => { },
};

export const LeadContext = createContext<LeadContextData>(initialState);

export default function LeadContextProvider({ children }: LeadContextProviderProps) {
    const { leads, setLeads, getAllLeads, getLeads, createLead } = useLead();

    return (
        <LeadContext.Provider
            value={{
                leads,
                setLeads,
                getAllLeads,
                getLeads,
                createLead,
            }}
        >
            {children}
        </LeadContext.Provider>
    );
}